module.exports = __webpack_public_path__ + "img/bg-about-footer.b8b2af8a.png";